import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import {
  StyledRadioButton,
  StyledRadioButtonIcon,
  StyledRadioButtonLabel
} from './RadioButton.styled';

export type RadioButtonProps = InputHTMLAttributes<HTMLInputElement> & {
  label: ReactNode;
  isLabelReversed?: boolean;
  isCard?: boolean;
};

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ label, id, isLabelReversed, isCard = false, ...other }, ref) => (
    <StyledRadioButton isCard={isCard}>
      <input type="radio" ref={ref} id={id} {...other} />

      <StyledRadioButtonLabel htmlFor={id} isLabelReversed={isLabelReversed}>
        <StyledRadioButtonIcon />
        <span>{label}</span>
      </StyledRadioButtonLabel>
    </StyledRadioButton>
  )
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
